import { Link } from "react-router-dom";
import type { NewsItem } from "@/mocks/news";

interface NewsCardProps {
  news: NewsItem;
  variant?: "list" | "grid";
}

export default function NewsCard({ news, variant = "list" }: NewsCardProps) {
  const path = `/news/detail/${news.id}`;

  if (variant === "grid") {
    return (
      <article className="group overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300">
        <Link to={path} className="block cursor-pointer" aria-label={news.title}>
          <div className="h-44 w-full overflow-hidden">
            <img
              src={news.cover}
              alt={news.title}
              title={`${news.title} - 色花堂娱乐资讯`}
              className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
          </div>
        </Link>
        <div className="p-4">
          <div className="flex items-center gap-2 text-xs text-foreground-500">
            <span className="rounded-full bg-primary-50 px-2 py-0.5 font-medium text-primary-700">
              {news.category}
            </span>
            <span>{news.date}</span>
          </div>
          <h3 className="mt-3 font-heading text-base font-bold leading-snug text-foreground-950">
            <Link to={path} className="line-clamp-2 transition-colors hover:text-primary-700 cursor-pointer">
              {news.title}
            </Link>
          </h3>
          <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-500">{news.summary}</p>
        </div>
      </article>
    );
  }

  return (
    <article className="group flex gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300">
      <Link to={path} className="hidden shrink-0 cursor-pointer sm:block" aria-label={news.title}>
        <div className="h-28 w-40 overflow-hidden rounded-md">
          <img
            src={news.cover}
            alt={news.title}
            title={`${news.title} - 色花堂娱乐资讯`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
      </Link>
      <div className="min-w-0 flex-1">
        <div className="flex flex-wrap items-center gap-2 text-xs text-foreground-500">
          <span className="rounded-full bg-primary-50 px-2 py-0.5 font-medium text-primary-700">
            {news.category}
          </span>
          <span>{news.date}</span>
          <span className="hidden items-center gap-1 sm:flex">
            <i className="ri-eye-line" aria-hidden="true"></i>
            {news.views.toLocaleString()}
          </span>
        </div>
        <h3 className="mt-2 font-heading text-base font-bold leading-snug text-foreground-950 md:text-lg">
          <Link to={path} className="line-clamp-1 transition-colors hover:text-primary-700 cursor-pointer">
            {news.title}
          </Link>
        </h3>
        <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-500">{news.summary}</p>
        <div className="mt-2 hidden flex-wrap items-center gap-2 sm:flex">
          {news.tags.map((tag) => (
            <span key={tag} className="text-xs text-accent-700">
              #{tag}
            </span>
          ))}
        </div>
      </div>
    </article>
  );
}